import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class BalaIntro extends Vue {
  submit() {
    this.$store.dispatch("updateBalaProgress", {
      section: "Reading Task",
      subsection: "Intro"
    });
    this.$router.push({ name: "balaRT1Intro" });
  }

  render(h: CreateElement) {
    return (
      <Card>
        <div slot="mainContent" class="subtitle-1">
          Reading is an important skill for learning new topics. BALA assesses
          your reading comprehension ability in the following areas:
          <v-img
            src={require("@/assets/bala_reading_explanation.png")}
            max-width="450px"
            style={{ margin: "0 auto" }}
          ></v-img>
        </div>
        <div slot="actions">
          <v-btn color="secondary" onClick={this.submit}>
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = BalaIntro;
